export default {
  path: '/anomaly-types',
  component: () =>
    import(
      '@/components/pages/AnomalyTypes/AnomalyTypes.vue'
    )
}
